import React from 'react';

import LookupStatusBadge from '~components/LookupStatusBadge';

import { CareRecipient, CareRecipientMatchStatus } from '~support-at-home/models/careRecipients';

interface ComponentProps {
  row: Pick<CareRecipient, 'match_status' | 'care_recipient_id'>;
}

// Bootstrap 5 badge shades, matching the Mandate Matching badge palette.
export const CARE_RECIPIENT_STATUSES: Record<CareRecipientMatchStatus, { name: string; colour: string }> = {
  matched: { name: 'Matched', colour: '198754' }, // bs-success
  suggested: { name: 'Suggested', colour: '0DCAF0' }, // bs-info
  unmatched: { name: 'Unmatched', colour: 'FFC107' }, // bs-warning
  conflict: { name: 'Conflict', colour: 'DC3545' }, // bs-danger
  unlinked: { name: 'Unlinked', colour: '6c757d' }, // bs-secondary
  ignored: { name: 'Ignored', colour: '6c757d' }, // bs-secondary
};

// Wide enough for the longest label ("Suggested") so every badge in the column has one width.
const BADGE_MIN_WIDTH = '6.5rem';

const unlinkedNote = (careRecipientId: string) =>
  `Imports still use this client while its Medicare Ref. is ${careRecipientId}. ` +
  `Change the client's Medicare Ref. to stop them.`;

const CareRecipientStatusBadge: React.FC<ComponentProps> = ({ row }) => {
  const tag = row.match_status;
  const known = CARE_RECIPIENT_STATUSES[tag];
  const badge = (
    <LookupStatusBadge
      status={{ tag, name: known?.name ?? tag, colour: known?.colour ?? '6c757d' }}
      dataCy={`sah-care-recipient-status-${tag}`}
      style={{ minWidth: BADGE_MIN_WIDTH, display: 'inline-block', textAlign: 'center' }}
    />
  );
  if (tag !== 'unlinked') return badge;
  return (
    <span title={unlinkedNote(row.care_recipient_id)} data-cy="sah-care-recipient-status-unlinked-note">
      {badge}
    </span>
  );
};

export default CareRecipientStatusBadge;
